/* unplugin-vue-components disabled */import script from "./HotelStockTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelStockTable.vue?vue&type=script&setup=true&lang=js"

import "./HotelStockTable.vue?vue&type=style&index=0&id=7b943728&lang=css"

const __exports__ = script;

export default __exports__